import React, { useMemo, useState, useEffect } from 'react';
import {
  Box, Typography, Paper, Grid, FormControl, InputLabel, Select, MenuItem, Button
} from '@mui/material';
import GaussianBellCurve from './GaussianBellCurve';

const scoreToQualitativeMap = {
  1: "5 - Bastante alejado del esperado",
  2: "4 - Desempeño por debajo del esperado",
  3: "3 - Desempeño esperado",
  4: "2 - Desempeño por encima del esperado",
  5: "1 - Excede ampliamente las expectativas",
};

const shortScoreLabels = {
  1: "Bastante Alejado",
  2: "Por Debajo",
  3: "Esperado",
  4: "Por Encima",
  5: "Excede Expectativas",
};

export default function PerformanceBySeniority({ data }) {
  const [selectedSeniority, setSelectedSeniority] = useState('');

  const senioritySummaries = useMemo(() => {
    if (!data || data.length === 0) return [];
    const summaries = data.map(item => {
      const totalCount = Object.values(item.distribucion_puntaje).reduce((sum, count) => sum + count, 0);
      let weightedSum = 0;
      Object.entries(item.distribucion_puntaje).forEach(([score, count]) => {
        weightedSum += parseInt(score) * count;
      });
      const averageScore = totalCount > 0 ? weightedSum / totalCount : 0;
      return { ...item, averageScore };
    });

    const order = { 'Jr': 1, 'SSR': 2, 'SR': 3, 'Leader/Manager': 4, 'N/A': 5 };
    return summaries.sort((a, b) => order[a.seniority] - order[b.seniority]);
  }, [data]);

  useEffect(() => {
    if (senioritySummaries.length > 0 && !selectedSeniority) {
      setSelectedSeniority(senioritySummaries[0].seniority);
    }
  }, [senioritySummaries, selectedSeniority]);

  const currentSeniorityData = useMemo(() => {
    return senioritySummaries?.find(item => item.seniority === selectedSeniority);
  }, [selectedSeniority, senioritySummaries]);

  const distribution = currentSeniorityData?.distribucion_puntaje || {};

  if (!data || data.length === 0) {
    return (
      <Paper elevation={3} sx={{ p: 3, borderRadius: '12px', textAlign: 'center' }}>
        <Typography variant="subtitle1">No hay datos de desempeño por seniority disponibles para el período seleccionado.</Typography>
      </Paper>
    );
  }

  return (
    <Paper elevation={3} sx={{ p: 3, borderRadius: '12px' }}>
      <Typography variant="h5" mb={2}>📈 Desempeño por Seniority</Typography>
      <FormControl fullWidth sx={{ mb: 3 }}>
        <InputLabel id="seniority-select-label">Seleccionar Seniority</InputLabel>
        <Select
          labelId="seniority-select-label"
          value={selectedSeniority}
          label="Seleccionar Seniority"
          onChange={(e) => setSelectedSeniority(e.target.value)}
        >
          {senioritySummaries.map((item) => (
            <MenuItem key={item.seniority} value={item.seniority}>
              {item.seniority}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {distribution && Object.keys(distribution).length > 0 ? (
        <GaussianBellCurve distribution={distribution} />
      ) : (
        <Typography variant="body2" color="text.secondary">No hay datos de distribución de puntaje para este seniority.</Typography>
      )}
    </Paper>
  );
} 